import $http from "../axios";

const actions = {
  uploadFile(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(data.to, data.data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

export default {
  actions
};
